import Vue, { CreateElement, VNode } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import i18n from './i18n';
import VueRx from 'vue-rx';
import { getCustomIconMixin } from '@/mixins/GetCustomIconMixin';
import { numberFormatMixin } from '@/mixins/NumberFormatMixin';
import VueLodash from 'vue-lodash';
import cloneDeep from 'lodash/cloneDeep';
import Notifications from 'vue-notification';
import NotificationServiceWrapper from './mixins/NotificationServiceWrapperMixin';
import { abilitiesPlugin } from '@casl/vue';
import { Ability, AnyAbility } from '@casl/ability';
import { dateFormatMixin } from './mixins/DateFormatMixin';

export const eventBus: Vue = new Vue();
export const singleUserEventBus: Vue = new Vue();

Vue.config.productionTip = false;

Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.use(VueRx);
Vue.use(VueLodash, { lodash: { cloneDeep } });
Vue.use(Notifications);

export const ability: AnyAbility = new Ability([]);
Vue.use(abilitiesPlugin, ability);

new Vue({
  router,
  store,
  i18n,
  render: (h: CreateElement): VNode => h(App)
}).$mount('#app');

Vue.mixin(getCustomIconMixin);
Vue.mixin(numberFormatMixin);
Vue.mixin(dateFormatMixin);
Vue.mixin(NotificationServiceWrapper);

(Vue.material as any).locale.dateFormat = 'dd/MM/yyyy';
